import { Box, Paper, Stack, Typography } from '@mui/material';
import { DashboardStats } from '../../types/dashboard';

interface PipelineOverviewCardProps {
  stats?: DashboardStats;
}

export const PipelineOverviewCard = ({ stats }: PipelineOverviewCardProps) => {
  const stages = [
    { label: 'Total leads', value: stats?.totalLeads ?? 0, color: 'primary.main' },
    { label: 'Registered', value: stats?.registered ?? 0, color: 'secondary.main' },
    { label: 'Admissions', value: stats?.admissions ?? 0, color: 'success.main' },
    { label: 'Payments', value: stats?.payments ?? 0, color: 'info.main' },
    { label: 'Ready to fly', value: stats?.readyToFly ?? 0, color: 'warning.main' },
    { label: 'Flown', value: stats?.flown ?? 0, color: 'text.secondary' },
  ];
  const max = Math.max(stages[0].value, 1);

  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        Pipeline overview
      </Typography>
      <Stack spacing={1.75}>
        {stages.map((stage) => {
          const widthPct = Math.max((stage.value / max) * 100, stage.value > 0 ? 4 : 0);
          return (
            <Box key={stage.label}>
              <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
                <Typography variant="body2">{stage.label}</Typography>
                <Typography variant="body2" sx={{ fontWeight: 700 }}>
                  {stage.value}
                </Typography>
              </Stack>
              <Box sx={{ height: 10, borderRadius: 5, bgcolor: 'action.hover', overflow: 'hidden' }}>
                <Box
                  sx={{
                    height: '100%',
                    width: `${widthPct}%`,
                    borderRadius: 5,
                    bgcolor: stage.color,
                    transition: 'width 0.4s ease',
                  }}
                />
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
};
